
<div class="modal-header" id="modalDialog">
  <h4 class="modal-title" id="modal-basic-title">{{titulo}}</h4>
  <button type="button" class="btn-close"aria-label="Close" (click)="dismissClick()">
  </button>
</div>
<div class="modal-body">
  @switch (data.id) {
    @case (1) { <!-- Acuse-->
   <oaj-acuse-itx [acuse]="data.obj"></oaj-acuse-itx>
  } 
  @case (2) {
    <oaj-demanda-detalle-itx [acuse]="data.obj"></oaj-demanda-detalle-itx>
  }
}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeClick()">Cerrar</button>
</div>
